import { GridLoader } from 'halogenium';
import * as React from 'react';
import '../assets/css/wait-spinner-card.css';

const getNextId = (() => {
  let id: number = 0;
  return (): string => {
    const prefixedId = ++id < 10000 ? `0000${id}`.substr(-4, 4) : String(id);
    return `wait_spinner_${prefixedId}`;
  };
})();

export interface WaitSpinnerCardProps {
  children?: React.ReactText;
}

class WaitSpinnerCard extends React.PureComponent<WaitSpinnerCardProps, { id: string }> {
  public state = { id: getNextId() };

  public render(): React.ReactNode {
    return (
      <div id={this.state.id} className="wait-spinner">
        <div className="card-wait-spinner">
          <div className="card-body">
            <GridLoader className="loader-icon" size="4px" color="#0074d1" verticalAlign="middle" />
            <span className="loader-text">{this.props.children}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default WaitSpinnerCard;
